import http from '@/http'
import { Auth } from '@/utility'

class UserStatusService {
    constructor() {
        this.intervalId = null
        this.isChecking = false
    }

    startPeriodicCheck() {
        // Verificar a cada 5 minutos (300000ms)
        this.intervalId = setInterval(() => {
            this.checkUserStatus()
        }, 300000)
    }

    stopPeriodicCheck() {
        if (this.intervalId) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
    }

    async checkUserStatus() {
        if (this.isChecking) return

        try {
            this.isChecking = true
            const jwt = Auth()

            if (!jwt || jwt.iss !== 'Controlsul' || jwt.exp <= new Date().getTime() / 1000) {
                return
            }

            const response = await http.get(
                `${window.URL_API_NODEJS}/user/status/${jwt.id}`
            )

            if (!response.data.active) {
                this.handleInactiveUser()
            }
        } catch (error) {
            console.error('Erro ao verificar status do usuário:', error)
        } finally {
            this.isChecking = false
        }
    }

    handleInactiveUser() {
        // Exibir notificação antes de desconectar
        if (window.Quasar && window.Quasar.notify) {
            window.Quasar.notify({
                message: 'Sua conta foi inativada. Você será desconectado.',
                type: 'warning',
                timeout: 3000
            })
        }

        // Aguardar um pouco para o usuário ver a notificação
        setTimeout(() => {
            localStorage.removeItem('tk_3000')
            window.location.href = '/login'
        }, 3000)
    }
}

export default new UserStatusService()